import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const token = sessionStorage.getItem("apc_token");

  if (!token) return <Navigate to="/login" replace />;

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#fdfbf7]">
        <div className="h-8 w-8 rounded-full border-2 border-emerald-800 border-t-transparent animate-spin" data-testid="auth-loading-spinner" />
      </div>
    );
  }

  if (!currentUser) return <Navigate to="/login" replace />;
  return children;
};
